import { useEffect, useState } from "react";
import OrganizationService from "../Organization.service";

const usePIIOptions = () => {
    const [PIIOptions, setPIIOptions] = useState<string[] | null>();
    const [activePIIOptions, setActivePIIOptions] = useState<string[] | null>();
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        let destroyed = false;

        const runFn = async () => {
            try {
                setIsLoading(true);
                const res = await OrganizationService.getPIIExtractionOptions();
                const res2 =
                    await OrganizationService.getActivePIIExtractionOptions();

                if (!destroyed) {
                    setPIIOptions(res);
                    setActivePIIOptions(res2.map((i) => i.extractionOption));
                    setIsLoading(false);
                }
            } catch (err) {
                console.error(err);
                setIsLoading(false);
            }
        };
        runFn();
        return () => {
            destroyed = true;
            setPIIOptions(null);
            setActivePIIOptions(null);
        };
    }, []);

    return {
        PIIOptions,
        activePIIOptions,
        setActivePIIOptions,
        isLoading,
    };
};

export default usePIIOptions;
